import { actionTypes } from "./actions";

const initialState = {
  settlements: [],
  loading: false,
  error: null,
};

export const customerSettlements = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_CUSTOMER_SETTLEMENTS:
      return {
        ...state,
        settlements: action.data,
        loading: false,
        error: null,
      };
    case actionTypes.SET_CUSTOMER_SETTLEMENTS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case actionTypes.SET_CUSTOMER_SETTLEMENTS_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};

export default customerSettlements;
